import { cva, VariantProps } from "cva";
import { ReactNode } from "react";

export type Props = {
  children: ReactNode;
} & VariantProps<typeof styles>;

const styles = cva({
  base: "min-h-14 text-xs bg-theme-overlay/25 text-theme-on-background p-3 rounded-md",
  variants: {},
});

export function InlineAlert({ children }: Props) {
  return <div className={styles()}>{children}</div>;
}
